module.exports = "<router-outlet></router-outlet>\n<div id=\"cover\"></div>"


//////////////////
// WEBPACK FOOTER
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main